export default __webpack_public_path__ + "static/media/Logo.0c55b443.svg";